import React from "react";

const NotificationList = ({ notifications, onClear }) => {
  return (
    <div className="w-full max-w-md mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
      <div className="px-4 py-3 bg-gray-100 border-b border-gray-200 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-gray-700">Notifications</h2>
        <button
          className="text-sm text-red-500 hover:text-red-700"
          onClick={onClear}
        >
          Clear All
        </button>
      </div>
      <ul className="divide-y divide-gray-200">
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <li
              key={index}
              className="px-4 py-4 hover:bg-gray-50 transition cursor-pointer"
            >
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div
                    className={`h-10 w-10 rounded-full flex items-center justify-center ${
                      notification.type === "success"
                        ? "bg-green-500"
                        : notification.type === "error"
                        ? "bg-red-500"
                        : "bg-blue-500"
                    } text-white`}
                  >
                    {notification.icon || "🔔"}
                  </div>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-800">
                    {notification.title}
                  </p>
                  <p className="text-sm text-gray-600">
                    {notification.message}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    {notification.time}
                  </p>
                </div>
              </div>
            </li>
          ))
        ) : (
          <li className="px-4 py-4 text-center text-gray-500">
            No notifications
          </li>
        )}
      </ul>
    </div>
  );
};

export default NotificationList;
